export default __webpack_public_path__ + "d798f02e38b84973ba9296851ca218fb.png";